const AbbsFurtherEducationHeader = [
    { id: 1, label: "Does the college offer PhD programmes?", var: "coursefee" },
    { id: 2, label: "Does the college offer postgraduate programmes?", var: "hostelfee" },
];

export default AbbsFurtherEducationHeader;
